export const INSURANCES = [
  'Skilled PPO/HMO',
  'Private Pay',
  'Medicare(Skilled)',
  'MED A HMO(Skilled)',
  'Medicaid',
  'Anthem',
  'Aetna',
  'Buckeye',
  'Molina',
  'UHC Commercial',
  'UHC Dual',
  'Humana',
  'Care Source',
];
